import { httpConfig } from '@/config';
import axios from 'axios';
import { BlogPost } from 'src/logic/models/blog';
import { PaginatedResponse } from 'src/logic/models/queries';

export const getAllBlogPosts = (page = 1, per_page = 10) => {
  return axios.get<{ data: PaginatedResponse<BlogPost> }>('/blogs', {
    params: {
      page,
      per_page,
    },
    baseURL: httpConfig.baseURL,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
};

export const getBlogPost = (slug: string) => {
  return axios.get<{ data: BlogPost }>(`/blogs/get-blog-by-slug/${slug}`, {
    baseURL: httpConfig.baseURL,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
};
